import React from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";

function Footer(props){

    function goToTop(){
        window.scrollTo(0,0);
    }

    function goToTopSmooth(){
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <footer className="footer footer--home">
            <div className="container">
                <div className="footer__nav">
                    {!props.isUserLoggedIn &&
                        (<ul className="footer__nav__list">
                            <li className="footer__nav__list__item footer__nav__list__item--title">
                                Resources
                            </li>
                            <li className="footer__nav__list__item">
                                <Link to="/survey-templates" onClick={goToTop}>Survey Templates</Link>
                            </li>
                            <li className="footer__nav__list__item">
                                <Link to="/help-center" onClick={goToTop}>Help Center</Link>
                            </li>
                            <li className="footer__nav__list__item">
                                <Link to="/pricing" onClick={goToTop}>Pricing</Link>
                            </li>
                        </ul>)
                    }

                    <ul className="footer__nav__list">
                        <li className="footer__nav__list__item footer__nav__list__item--title">
                            About
                        </li>
                        <li className="footer__nav__list__item">
                            <Link to="/contact" onClick={goToTop}>Contact</Link>
                        </li>
                        {props.isUserLoggedIn &&
                        (
                            <li className="footer__nav__list__item">
                                <Link to="/help-center" onClick={goToTop}>FAQ</Link>
                            </li>
                        )}
                        <li className="footer__nav__list__item">
                            <a href="/help-center/legal/terms">Terms & Conditions</a>
                        </li>
                        <li className="footer__nav__list__item">
                            <a href="/help-center/legal/data-protection">Privacy Policy</a>
                        </li>
                        <li className="footer__nav__list__item">
                            <a href="/help-center/legal/cookie">Cookies Policy</a>
                        </li>
                    </ul>
                    <div className="footer__nav__subscribe">
                        <span className="footer__nav__subscribe__title">Follow Us</span>
                        {/*<span className="footer__nav__subscribe__text">*/}
                            {/*Weekly newsletter of news and updates about bubblyPolls*/}
                        {/*</span>*/}
                        {/*<div className="footer__nav__subscribe__form">*/}
                            {/*<input type="text" placeholder="youremail@mail.com"/>*/}
                            {/*<a href="">Subscribe</a>*/}
                        {/*</div>*/}
                        <div className="footer__nav__subscribe__social">
                            <a href="https://www.facebook.com/bubblyPolls" target="_blank"><img src="/assets/img/homepage/facebook.svg" alt=""/></a>
                            <a href="https://www.linkedin.com/company/bubblypolls/" target="_blank"><img src="/assets/img/homepage/linkedin.svg" alt=""/></a>
                            <a href="https://twitter.com/BubblyPolls" target="_blank"><img src="/assets/img/homepage/twitter.svg" alt=""/></a>
                        </div>
                    </div>
                </div>
                <div className="footer__bubbly">© bubblyPolls 2022</div>
                <div className="footer__gotop" onClick={goToTopSmooth}></div>
            </div>
        </footer>
    );

}

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

export default connect(mapStateToProps, null)(Footer);